import { Component, inject, OnInit } from '@angular/core'
import { RouterModule } from '@angular/router'

import { ThemeService, ToggleComponent, TypographyComponent } from '@hyperkit'

@Component({
  standalone: true,
  imports: [TypographyComponent, RouterModule, ToggleComponent],
  templateUrl: './appearance.component.html',
  styleUrls: ['./appearance.component.scss'],
})
export class AppearanceComponent implements OnInit {
  private readonly themeService = inject(ThemeService)
  public theme: string

  public ngOnInit(): void {
    this.theme = this.themeService.theme()
  }

  public toggleTheme(): void {
    this.themeService.toggleTheme()
  }
}
